import * as urls from '../config'
import axios from 'axios'

export default {
  getNoticias (perPage, page = 1, tags = '') {
    if (tags !== '') {
      tags = '&tags=' + tags
    }
    let service = urls.WP_URL + 'noticias-publicadas/?per_page=' + perPage + '&page=' + page + '&_embed' + tags
    return axios.get(service)
    .then(response => {
      return response
    })
    .catch(error => {
      console.log(error)
    })
  },
  getNoticia (id) {
    let service = urls.WP_URL + 'noticias-publicadas/' + id + '?_embed'
    return axios.get(service)
    .then(response => {
      return response.data
    })
    .catch(error => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/api/NoticiaService.js